import axios from 'axios';
import { getCatalogosApiService } from './CatalogosApiService';

class MenuService {
    constructor() {
        this.baseURL = process.env.VUE_APP_API_URL + "/administracion/v1";
        this.catalogService = getCatalogosApiService();
    }

    /**
     * Obtiene el menú dinámico para un usuario específico
     * @param {string} numeroEmpleado - Número de empleado del usuario
     * @returns {Promise<Array>} Lista de elementos del menú
     */
    async getMenuByUsuario(numeroEmpleado) {
        try {
            const timestamp = new Date().getTime();
            const response = await axios.get(`${this.baseURL}/menu/usuario/${numeroEmpleado}?t=${timestamp}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Obtiene el menú para un usuario en un sistema específico
     * @param {string} numeroEmpleado - Número de empleado del usuario
     * @param {number} sistemaId - ID del sistema
     * @returns {Promise<Array>} Lista de elementos del menú
     */
    async getMenuByUsuarioAndSistema(numeroEmpleado, sistemaId) {
        try {
            const response = await axios.get(`${this.baseURL}/menu/usuario/${numeroEmpleado}/sistema/${sistemaId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Obtiene el menú del usuario logueado
     * @returns {Promise<Array>} Lista de elementos del menú
     */
    async getCurrentUserMenu() {
        const numeroEmpleado = localStorage.getItem('usuario');
        if (!numeroEmpleado) {
            throw new Error('Usuario no encontrado en localStorage');
        }
        return this.getMenuByUsuario(numeroEmpleado);
    }

    /**
     * Convierte el menú de la API al formato esperado por el componente Menu
     * @param {Array} menuData - Datos del menú desde la API
     * @returns {Array} Menú en formato para el componente
     */
    convertToMenuFormat(menuData) {
        return menuData.map(item => ({
            title: item.title || item.acceso || 'Sin Título',
            icon: item.icon || 'folder-open',
            orden: item.orden || 99,
            subMenu: item.subMenu ? item.subMenu.map(subItem => ({
                title: subItem.title || subItem.subacceso || 'Sin Título',
                icon: subItem.icon || 'star',
                route: subItem.route || subItem.path || '',
                orden: subItem.orden || 1
            })) : []
        }));
    }
}

export default MenuService;
